import { imgSrcAttributes } from 'helpers/common';
import * as React from 'react';
require('./style.css');

interface IProps {
	imageUrl: string;
	children?: any;
	onClick?: any;
}
/**
 *
 * @param props
 */
const Avatar = (props: IProps) => {
	const { imageUrl, children, onClick } = props;
	const onImageClick = (e) => {
		if (onClick) {
			onClick(e);
		}
	};

	return (
		<div className="avatarHolder">
			{children}
			<img className="avatarImage" {...imgSrcAttributes(imageUrl)} onClick={(e) => onImageClick(e)} />
		</div>
	);
};

export { Avatar };
